import { render, staticRenderFns } from "./Research.vue?vue&type=template&id=1d275a6c&scoped=true"
import script from "./Research.vue?vue&type=script&lang=js"
export * from "./Research.vue?vue&type=script&lang=js"
import style0 from "./Research.vue?vue&type=style&index=0&id=1d275a6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d275a6c",
  null
  
)

export default component.exports